<template>
  <div class="datetime-selector-inline">
    <div v-if="editMode">
      <el-date-picker
        ref="date_selector"
        v-model="selectedDate"
        type="datetime"
        placeholder="Select date and time"
        default-time="08:00:00"
        @blur="onSave"
        @change="onUpdate">
      </el-date-picker>
      <el-button
        v-if="show_never_button"
        size="mini"
        type="info"
        @click="onNeverOrToday"
        style="position: relative">{{button_text}}</el-button>
      <el-button
        v-if="show_confirm_button"
        size="mini"
        type="success"
        @click="onSave"
        style="position: relative">ok</el-button>
    </div>
    <template v-if="!editMode">
      <div @click.prevent="onStartEditMode">
        <template v-if="selectedDate">
          <template >
            <div :class="[ disabled ? 'date-selector-inline-disabled' : 'date-selector-inline-enabled']">
              {{ display_value }}
            </div>
          </template>
        </template>
        <template v-else>{{text_if_empty}}</template>
      </div>
    </template>
  </div>
</template>

<script>
import moment from '@/moment-gp'

export default {
  props: {
    type: {
      default: "date"
    },
    show_never_button: {
      default: true
    },
    show_confirm_button: {
      default: false
    },
    placeholder: {
      default: 'Pick a day'
    },
    text_if_empty: {
      default: 'never'
    },
    value: {
      default: () => ([])
    },
    size: {
      default: 'medium'
    },
    disableBefore: {
      default: null // '2018-11-20'
    },
    defaultIsToday: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    button_text: '',
    selectedDate: null,
    editMode: false
  }),
  computed: {
    display_value() {
      return  this.showTime ? this.$options.filters.shortTime(this.selectedDate) : this.$options.filters.shortDateNumeric(this.selectedDate)
    }
  },
  mounted() {
    /* DateSelector can handle it */
    this.selectedDate = this.value;

    if ( this.defaultIsToday ) {
      this.button_text = 'today';
    } else {
      this.button_text = this.text_if_empty;
    }
  },
  watch: {
    value(newValue) {
      this.selectedDate = newValue;
    }
  },
  methods: {
    onStartEditMode() {
      if (!this.disabled) {
        this.editMode = !this.editMode;
        this.$nextTick(() => {
          this.$refs.date_selector.focus();
        })
      }
    },

    onUpdate() {
      // console.log("this.selectedDate", this.selectedDate);
      this.$emit('input', this.selectedDate);
      if ( !this.show_confirm_button ) {
        this.onSave();
      }
    },

    onNeverOrToday() {
      console.log("onNeverOrToday");
      if ( this.defaultIsToday ) {
        this.selectedDate = moment.currentDate();
      } else {
        this.selectedDate = null;
      }
      this.$emit('input', this.selectedDate);
      this.onSave();
    },

    onSave() {
      this.editMode = false;
      this.$emit('save', this.selectedDate)
    },

    onUnfocus() {
      /* We need to wait a little bit otherwise the button click on neveOrToday
        does not get triggered */
      setTimeout(() => {
        this.editMode = false;
      }, 100)
    },
    reset( value ) {
      this.selectedDate = value || this.value;
    }
  }
}
</script>

<style>
.datetime-selector-inline .inline-date-select {
  display: inline-block;
  margin: 0 0.1em;
  width: 11em;
}
.datetime-selector-inline {
  display: inline-block;
  position: relative;
}
.datetime-selector-inline-disabled {
  color: #000000;
}
.datetime-selector-inline-disabled:hover {
  text-decoration: none !important;
  text-decoration-line: none !important;
}
.datetime-selector-inline-enabled {
  color: rgb(64, 158, 255);
}
.datetime-selector-inline-enabled:hover {
  text-decoration: underline
}
</style>
